import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero: React.FC = () => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const [currentVideoIndex, setCurrentVideoIndex] = React.useState(0);
  
  const videos = [
    '/videos/pickup-truck-boat-ramp-lake.mp4',
    '/videos/pickup-truck-boat-ramp-river.mp4',
    '/videos/Pickup_Truck_Pulling_Boat.mp4'
  ];
  
  React.useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5; // Slow down by 2x (half speed)
      
      // Ensure video starts playing
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Auto-play was prevented, but video will still cycle when manually started
        });
      }
    }
  }, [currentVideoIndex]);

  const handleVideoEnd = () => {
    // Cycle to the next video
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  const handleVideoError = () => {
    // If there's an error with the current video, try the next one
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  return (
    <section className="hero" id="home">
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className="hero-video"
        onEnded={handleVideoEnd}
        onError={handleVideoError}
        key={currentVideoIndex}
      >
        <source src={videos[currentVideoIndex]} type="video/mp4" />
      </video>
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <h1>Premium Boat Trailers for Every Adventure</h1>
          <p>
            Get your boat to the water safely and efficiently with our high-quality,
            durable boat trailers. Built to last, designed for performance.
          </p>
          <div className="hero-buttons">
            <a href="tel:410-570-9150" className="btn btn-call">Call Us</a>
            <Link to="/inventory" className="btn btn-inventory">Current Inventory</Link>
            <a href="#trailer-finder" className="btn btn-secondary">Help me pick a trailer</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;